export enum ClaimPaymentConstants {
  MaxDraftNotesCharacters = 240,
  MaxEmailNotesCharacters = 4000,
}
